import React from 'react';
import { Clock } from 'lucide-react';
import { formatPublishNp } from '../../utils/timeAgo';
import Watermark from './Watermark';

function NewsCard({ item, size = 'md', onOpen }) {
  const parsePhotos = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const imageUrl = item.image || parsePhotos(item.photos)[0] || null;
  const placeholder = 'https://via.placeholder.com/800x600?text=Kalo+Jhola';

  return (
    <article
      className={`group cursor-pointer min-w-0 ${size === 'lg' ? 'news-card--lg' : ''}`}
      onClick={() => onOpen(item)}
      role="button"
      tabIndex={0}
    >
      <div className={`relative rounded-xl overflow-hidden mb-3 ${size === 'lg' ? 'aspect-[16/10]' : 'aspect-[4/3]'} bg-paper-soft`}>
        <img
          src={imageUrl || placeholder}
          alt={item.title}
          loading="lazy"
          className="w-full h-full object-cover max-sm:object-contain transition-transform duration-300 group-hover:scale-102"
        />
        {/* Watermark logo */}
        <Watermark />
      </div>
      <h3 className={`font-display font-semibold leading-snug mb-2 transition-colors group-hover:text-blue ${size === 'lg' ? 'text-[22px]' : 'text-[19px]'}`}>
        {item.title}
      </h3>
      {item.excerpt && size !== 'sm' && (
        <p className="text-[15px] text-muted leading-relaxed mb-2.5 line-clamp-2">{item.excerpt}</p>
      )}
      <div className="flex items-center gap-1.5 text-xs text-muted flex-wrap">
        <Clock size={13} />
        <span>{formatPublishNp(item.created_at || item.date)}</span>
        {item.read_time && (
          <>
            <span className="opacity-50">•</span>
            <span>{item.read_time} मिनेट पढाइ</span>
          </>
        )}
      </div>
    </article>
  );
}

export default NewsCard;
